import angular from 'angular';

export default function scrollToSelected($parse) {
  'ngInject';

  return {
    restrict: 'A',
    link($scope, $element, $attrs) {
      if ('scrollToSelectedEnabled' in $attrs && !$scope.$eval($attrs.scrollToSelectedEnabled)) {
        return;
      }

      const toggle = $element[0].querySelector('[uib-dropdown-toggle]');

      function getSelectedValue() {
        if ('scrollToSelectedBinding' in $attrs) {
          return $parse($attrs.scrollToSelectedBinding)($scope);
        }

        return $attrs.scrollToSelected || toggle.textContent || toggle.value;
      }

      function findBestQualityElementPair(target, options, qualityFn) {
        return options.reduce(
          (acc, option, index) => {
            const q = qualityFn({
              $value: target,
              $candidate: option.textContent.trim(),
              $candidateIndex: index,
            });

            return q < acc[0] ? [q, option] : acc;
          },
          [Number.MAX_VALUE, options[0]]
        );
      }

      function matchElement(options, selectedValue) {
        if ('scrollToSelectedCompare' in $attrs) {
          const q = $parse($attrs.scrollToSelectedCompare).bind(null, $scope);
          return findBestQualityElementPair(selectedValue, options, q)[1];
        }
        return options.find((o) => o.textContent.trim().indexOf(selectedValue) >= 0);
      }

      angular.element(toggle).on('click', () => {
        $scope.$$postDigest(() => {
          if ($element.hasClass('open')) {
            const dropdown = $element[0].querySelector(
              '[uib-dropdown-menu].scrollable, [uib-dropdown-menu] .scrollable, [uib-dropdown-menu].scrollable-small'
            );

            if (!dropdown) {
              return;
            }

            const options = Array.prototype.slice.call(dropdown.querySelectorAll('li a'));
            if (options.length) {
              const selectedValue = getSelectedValue();
              const selected = matchElement(options, selectedValue);
              if (selected) {
                dropdown.scrollTop =
                  selected.getBoundingClientRect().top - options[0].getBoundingClientRect().top;
              }
            }
          }
        });
      });
    },
  };
}
